(() => {
  const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  const finePointerQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
  const root = document.body;

  if (!root) return;

  let cursorFrame = 0;
  let cursorX = 50;
  let cursorY = 20;

  const updateCursorGlow = () => {
    cursorFrame = 0;
    root.style.setProperty('--saint-avs-cursor-x', `${cursorX}%`);
    root.style.setProperty('--saint-avs-cursor-y', `${cursorY}%`);
    root.style.setProperty('--saint-avs-cursor-x-px', `${(window.innerWidth * cursorX) / 100}px`);
    root.style.setProperty('--saint-avs-cursor-y-px', `${(window.innerHeight * cursorY) / 100}px`);
    root.style.setProperty('--sa-mouse-x', `${cursorX}%`);
    root.style.setProperty('--sa-mouse-y', `${cursorY}%`);
    root.style.setProperty('--sa-cursor-x', `${(window.innerWidth * cursorX) / 100}px`);
    root.style.setProperty('--sa-cursor-y', `${(window.innerHeight * cursorY) / 100}px`);
  };

  const handlePointerMove = (event) => {
    if (motionQuery.matches || !finePointerQuery.matches) return;

    cursorX = (event.clientX / window.innerWidth) * 100;
    cursorY = (event.clientY / window.innerHeight) * 100;

    if (!cursorFrame) {
      cursorFrame = window.requestAnimationFrame(updateCursorGlow);
    }
  };

  const tiltSelector = [
    '.saint-avs-page-banner',
    '.saint-avs-hero',
    '.saint-avs-hero__panel',
    '.saint-avs-shop-note',
    '.saint-avs-start',
    '.saint-avs-start-card',
    '.saint-avs-support',
    '.saint-avs-youtube-card',
    '.saint-avs-latest-card',
    '.saint-avs-featured-grid a',
    '.saint-avs-card',
    '.saint-avs-study-tools__hero',
    '.saint-avs-study-tool-card',
    '.saint-avs-studies-hub__hero',
    '.saint-avs-studies-hub__free-note',
    '.saint-avs-studies-hub__card',
    '.saint-avs-studies-hub__support',
    '.saint-avs-studies-hub__sidebar-panel',
    '.saint-avs-news-hub__hero',
    '.saint-avs-news-hub__featured',
    '.saint-avs-news-hub__empty',
    '.saint-avs-news-hub__card',
    '.saint-avs-news-hub__sidebar-panel',
    '.avs-games-hero',
    '.saint-avs-support-page__hero',
    '.saint-avs-support-page__hero-panel',
    '.saint-avs-support-page__copy',
    '.saint-avs-support-page__free-note',
    '.saint-avs-support-card',
    '.saint-avs-support-product',
    '.avs-header__dropdown-menu',
    '.section-resource-list__header',
    '.product-card',
    '.product-grid__card',
    '.collection-card',
    '.resource-card',
    '.blog-post-card',
    '.featured-blog-posts-card',
  ].join(',');

  const blockedInteractiveSelector = [
    'form',
    'input',
    'textarea',
    'select',
    'button[type="submit"]',
    '.shopify-payment-button',
    '.cart',
    '.cart-drawer',
    '.cart-items',
    '.cart-summary',
    '.checkout',
    '[name*="engraving" i]',
    '[id*="engraving" i]',
    'product-form-component',
    'quick-add-modal',
  ].join(',');

  const resetTilt = (element) => {
    element.style.setProperty('--saint-avs-tilt-x', '0deg');
    element.style.setProperty('--saint-avs-tilt-y', '0deg');
    element.style.setProperty('--saint-avs-local-x', '50%');
    element.style.setProperty('--saint-avs-local-y', '50%');
  };

  const bindTilt = () => {
    if (motionQuery.matches || !finePointerQuery.matches) return;

    document.querySelectorAll(tiltSelector).forEach((element) => {
      if (element.dataset.saintAvsTiltBound === 'true') return;
      if (element.closest(blockedInteractiveSelector) || element.querySelector(blockedInteractiveSelector)) return;

      element.dataset.saintAvsTiltBound = 'true';
      element.classList.add('saint-avs-tilt-target');

      element.addEventListener('pointermove', (event) => {
        const rect = element.getBoundingClientRect();
        const x = (event.clientX - rect.left) / rect.width;
        const y = (event.clientY - rect.top) / rect.height;
        const tiltY = (x - 0.5) * 5.5;
        const tiltX = (0.5 - y) * 4.5;

        element.style.setProperty('--saint-avs-tilt-x', `${tiltX.toFixed(2)}deg`);
        element.style.setProperty('--saint-avs-tilt-y', `${tiltY.toFixed(2)}deg`);
        element.style.setProperty('--saint-avs-local-x', `${(x * 100).toFixed(1)}%`);
        element.style.setProperty('--saint-avs-local-y', `${(y * 100).toFixed(1)}%`);
      });

      element.addEventListener('pointerleave', () => resetTilt(element));
    });
  };

  document.addEventListener('pointermove', handlePointerMove, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindTilt, { once: true });
  } else {
    bindTilt();
  }

  document.addEventListener('shopify:section:load', bindTilt);
})();
